import { Component } from "@kluntje/core";
import { renderTemplate } from "Helper/renderHelper/renderTemplate";
import LocalEventsService from "Services/LocalEventsService";

export class SDEEventsOverviewContentBox extends Component {
  protected afterComponentRender(): void {
    this.init();
  }

  private async init() {
    const events = await LocalEventsService.getEvents({
      locations: ["Süderende"],
      pageSize: 2,
    });

    if (events === null) return;

    const { contentTemplate } = await import("./sde-m-events-overview-content-box.template");
    renderTemplate(contentTemplate({ events: events.events }), this, { clearSSRContent: true });
  }
}

customElements.define("sde-m-events-overview-content-box", SDEEventsOverviewContentBox);
